import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { getMarkingDraftOwner, getMarkingDraftController } from '../utils/markingDraftStore';

export default function useMarkingRecovery(apiUrl, snapshot, applySnapshot) {
  const controllerRef = useRef(undefined);
  if (controllerRef.current === undefined) controllerRef.current = getMarkingDraftController(getMarkingDraftOwner(apiUrl));
  const controller = controllerRef.current;
  const applyRef = useRef(applySnapshot); applyRef.current = applySnapshot;
  const [ready, setReady] = useState(!controller);
  const [status, setStatus] = useState({ status: controller ? 'loading' : 'disabled', error: '', savedAt: null, recovered: false, interrupted: false });
  const paused = useRef(false);
  useEffect(() => {
    if (!controller) return;
    let active = true;
    const unsubscribe = controller.subscribe((current, reason) => {
      if (!active) return;
      if (reason === 'job' && current.state) applyRef.current(current.state, Boolean(current.activeRun));
      setStatus(previous => ({ ...previous, status: current.status, error: current.error, savedAt: current.savedAt,
        interrupted: Boolean(current.state?.interrupted) }));
    });
    controller.load().then(state => {
      if (!active) return;
      if (state) applyRef.current(state, Boolean(controller.activeRun));
      setStatus(previous => ({ ...previous, recovered: Boolean(state), interrupted: Boolean(state?.interrupted) }));
      setReady(true);
    });
    const flush = () => controller.flush();
    window.addEventListener('pagehide', flush);
    return () => { active = false; unsubscribe(); window.removeEventListener('pagehide', flush); controller.flush(); };
  }, [controller]);

  useLayoutEffect(() => {
    if (!controller || !ready || paused.current) return;
    const meaningful = snapshot.examFile || snapshot.examFiles?.length || snapshot.memoFile || snapshot.marking
      || snapshot.batchItems?.length || snapshot.selection?.subjectId;
    if (meaningful) controller.patch(snapshot);
  }, [controller, ready, snapshot]);

  const clear = async () => {
    paused.current = true;
    try {
      await controller?.clear();
      setStatus({ status: 'ready', error: '', savedAt: null, recovered: false, interrupted: false });
    } finally { paused.current = false; }
  };
  return { controller, ready, ...status, clear };
}
